// Documento: Configurar la integración a TikTok en Etiqueta Blanca
// Categoría: Etiqueta Blanca
// Última actualización: 2025-10-16

const document = {
  "id": "configurar-integracion-tiktok-etiqueta-blanca",
  "title": "Configura la integración a TikTok",
  "category": "Etiqueta Blanca",
  "description": "Guía completa para configurar la integración de TikTok Business Messaging en su etiqueta blanca. Esta integración permite que las Cuentas de Empresa envíen y reciban mensajes directos (DMs) con usuarios de TikTok dentro de tu Whitelabel.",
  "explanations": [
    {
      "title": "¿Qué es TikTok Business Messaging?",
      "content": "La Mensajería para Empresas de TikTok (TikTok's Business Messaging) permite que las Cuentas de Empresa envíen y reciban mensajes directos (DMs) con usuarios de TikTok dentro de tu Whitelabel.\nEsto ayuda a las empresas a mejorar la interacción con los clientes y optimizar los flujos de mensajería a través de nuestra plataforma.\n\n⚠️ **Importante:**\nEsta documentación es exclusiva para los propietarios de Etiqueta Blanca.\nSi no tienes un Etiqueta Blanca, no leas esta documentación.\n\nEs necesario crear su propia aplicación de TikTok para permitir que las empresas accedan a TikTok Business Message."
    },
    {
      "title": "Disponibilidad regional y revisiones requeridas",
      "content": "**Restricciones geográficas:**\n\nLa API de TikTok Business Messaging aún no está disponible en el Espacio Económico Europeo (EEE), Suiza o el Reino Unido.\n\nPara las Cuentas de Empresa registradas en esas regiones, TikTok Automation no está disponible.\n\nAdemás, los mensajes directos enviados desde cuentas de TikTok en esas regiones no pueden ser automatizados, incluso si se trata de una cuenta de empresa."
    }
  ],
  "steps": [
    {
      "title": "Crea una cuenta de TikTok For Business",
      "content": "El primer paso es crear una cuenta de TikTok For Business siguiendo la documentación oficial de TikTok.\n\n📎 Consulta la documentación oficial: https://business-api.tiktok.com/portal/docs?id=1738855099573250",
      "images": []
    },
    {
      "title": "Regístrate como desarrollador",
      "content": "Una vez que tengas tu cuenta de TikTok For Business, debes registrarte como desarrollador en la plataforma.\n\n📎 Consulta la documentación oficial: https://business-api.tiktok.com/portal/docs?id=1738855176671234",
      "images": []
    },
    {
      "title": "Crea una aplicación de desarrollador (developer app)",
      "content": "Crea tu aplicación de desarrollador siguiendo las instrucciones de TikTok.\n\n📎 Consulta la documentación oficial: https://business-api.tiktok.com/portal/docs?id=1738855242728450",
      "images": []
    },
    {
      "title": "Configura la URL de autorización de anunciantes",
      "content": "Después de crear la app, ve a **Basic Information** y configura la siguiente URL:\n\n**Advertiser authorization URL:**\nhttps://SUB_DOMAIN/auth/tiktok\n\n⚠️ Reemplaza SUB_DOMAIN con tu subdominio real.",
      "images": [
        "/documents/tiktok-wl/1.png"
      ]
    },
    {
      "title": "Incluye los scopes de permisos requeridos",
      "content": "Incluye los siguientes scopes de permisos en tu aplicación:\n\n• **Ad Account Management**\n• **CTX Events Management**\n• **Measurement**\n\nEstos permisos son necesarios para el correcto funcionamiento de la integración.",
      "images": [
        "/documents/tiktok-wl/2.png"
      ]
    },
    {
      "title": "Solicita acceso a TikTok Business Message",
      "content": "Inicia tu solicitud enviando tu información a través del formulario oficial de TikTok:\n\n📎 Formulario de solicitud: https://bytedance.sg.larkoffice.com/share/base/form/shrlg7vFArGhg9V20neYCEwIKrb\n\n⚠️ **Importante:**\nCuando completes el formulario, **no incluyas \"United States\"** en la sección **Managed Business Account Regions**, ya que esto aumenta considerablemente el tiempo de aprobación.\n\nEl equipo de TikTok API for Business procesará tu solicitud e iniciará la revisión dentro de los 10 días hábiles posteriores al envío.\n\n📎 Consulta la documentación oficial para más información: https://business-api.tiktok.com/portal/docs?id=1832184145137922",
      "images": [
        "/documents/tiktok-wl/3.png"
      ]
    },
    {
      "title": "Accede a la configuración de integraciones en tu Whitelabel",
      "content": "Una vez que tu aplicación haya sido aprobada para usar TikTok Business Message, dirígete a:\n\n**Whitelabel settings > Integration**",
      "images": [
        "/documents/tiktok-wl/4.png"
      ]
    },
    {
      "title": "Identifica los valores necesarios",
      "content": "Para completar la integración necesitarás los siguientes valores de tu aplicación de TikTok:\n\n• **App ID**\n• **Secret key**\n\nEstos valores los obtendrás en el siguiente paso.",
      "images": [
        "/documents/tiktok-wl/5.png"
      ]
    },
    {
      "title": "Obtén las credenciales de tu aplicación de TikTok",
      "content": "Podrás obtener el **App ID** y la **Secret key** desde la configuración de tu aplicación de TikTok en el portal de desarrolladores.\n\nCopia estos valores y guárdalos de forma segura, ya que los necesitarás para completar la integración en tu Whitelabel.",
      "images": [
        "/documents/tiktok-wl/6.png"
      ]
    },
    {
      "title": "Completa la configuración en tu Whitelabel",
      "content": "Ingresa el **App ID** y la **Secret key** en la configuración de integraciones de tu Whitelabel.\n\nUna vez completos todos estos pasos y que TikTok apruebe su formulario, intente conectar TikTok.\n\n⚠️ Si recibe un error, por favor contáctenos para asistencia técnica."
    }
  ],
  "tags": [
    "etiqueta-blanca",
    "tiktok",
    "business-messaging",
    "integracion",
    "configuración",
    "api",
    "developer-app"
  ],
  "lastUpdated": "2025-10-16",
  "difficulty": "avanzado"
};

export default document;

